import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';

const Cta = ({ title, link, selector, customClass }) => {
	const scrollOpts = { behavior: 'smooth', inline: 'center', block: 'start' };

	const scrollTo = () => {
		const element = document.querySelector(selector);

		element?.scrollIntoView(scrollOpts);
	};

	return selector ? (
		<button className={customClass} onClick={scrollTo}>
			{title}
		</button>
	) : (
		link && (
			<Link to={link} className={customClass} >
				{title}
			</Link>
		)
	);
};

Cta.propTypes = {
	title: PropTypes.string,
	link: PropTypes.string,
	selector: PropTypes.string,
	customClass: PropTypes.string,
	customLink: PropTypes.string,
};

Cta.defaultProps = {
	title: '',
	link: null,
	selector: null,
	customClass: 'btn btn--secondary',
	customLink: '',
};

export default Cta;
